import React from 'react'
import PropTypes from 'prop-types'

export const ConfirmationDialog = (props) =>
  <div className='confirmation-dialogue'>
    <h3>{props.heading}</h3>
    {props.subheading && <h4>{props.subheading}</h4>}
    {props.primaryButton && props.primaryButton()}
    {props.secondaryButton && props.secondaryButton()}
  </div>

ConfirmationDialog.propTypes = {
  heading: PropTypes.string.isRequired,
  // The FNA delete screens pass no subheading, so requiring it only produced
  // a console warning on screens that render correctly without one.
  subheading: PropTypes.string,
  primaryButton: PropTypes.func,
  secondaryButton: PropTypes.func
}
